type CustomSizeRenderingInput = {
  optionId: string;
  optionType: string;
  hasValues: boolean;
  hasCustomSizeValue: boolean;
  forceDropdownRadioOptions: boolean;
  hasCompactSingleValue: boolean;
};

/**
 * De normale `size`-route rendert de eigen-maatvelden al binnen
 * GroupedSizeSelector. Het oudere losse paneel is alleen nog nodig als die
 * selector bewust wordt overgeslagen (dropdownmodus of één compacte waarde).
 */
export function shouldRenderSeparateCustomSizePanel({
  optionId,
  optionType,
  hasValues,
  hasCustomSizeValue,
  forceDropdownRadioOptions,
  hasCompactSingleValue,
}: CustomSizeRenderingInput): boolean {
  // Het optietype telt niet mee: Print.com-maten met een eigen-maatwaarde zijn
  // in de database ook als `select` of `radio` opgeslagen (sleeves, forex).
  // Doorslaggevend is dat er een waarde met `customSizes` bestaat.
  void optionType;
  if (optionId !== 'size' || !hasValues || !hasCustomSizeValue) return false;
  return forceDropdownRadioOptions || hasCompactSingleValue;
}

type InlineCustomSizeInputsInput = {
  hasInputHandler: boolean;
  selectedValue: string | null | undefined;
  customValues: ReadonlyArray<string>;
};

/**
 * GroupedSizeSelector valt terug op een plat raster zodra een indeling in
 * staand/liggend niet zinvol is: bij 3D-verpakkingsmaten (sleeves, dozen), bij
 * vormen, of als er maar één richtingsgroep is. Dat platte raster toonde wel
 * de tegel "Eigen formaat", maar nooit de velden voor breedte en hoogte,
 * waardoor die keuze niet te bestellen was. Is de gekozen waarde de
 * eigen-maatwaarde, dan horen de velden er dus altijd onder.
 */
export function shouldShowInlineCustomSizeInputs({
  hasInputHandler,
  selectedValue,
  customValues,
}: InlineCustomSizeInputsInput): boolean {
  if (!hasInputHandler || !selectedValue) return false;
  return customValues.includes(String(selectedValue));
}
